/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropclaimwindowdays3Inputs */

const en_dropclaimwindowdays3 = /** @type {(inputs: Dropclaimwindowdays3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim window (days)`)
};

const de_dropclaimwindowdays3 = /** @type {(inputs: Dropclaimwindowdays3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlösefrist (Tage)`)
};

/**
* | output |
* | --- |
* | "Claim window (days)" |
*
* @param {Dropclaimwindowdays3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropclaimwindowdays3 = /** @type {((inputs?: Dropclaimwindowdays3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropclaimwindowdays3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropclaimwindowdays3(inputs)
	return de_dropclaimwindowdays3(inputs)
});
export { dropclaimwindowdays3 as "dropClaimWindowDays" }